import React from "react";
import { Row, Col } from "react-bootstrap";
import { useParams } from "react-router";

import HeaderBox from "../../../reuseableComponents/headerBox";
import ChemicalRuleViolationTable from "./ChemicalRuleViolationsTable";

const IpsReportHome = () => {
  let { systemId } = useParams();
  return (
    <>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"}>
            <h3 style={{ color: "#fff", padding: "0.5rem" }} cypressid='IpsReport'>
              IPS Report
            </h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Chemical Monitoring Rule Violations</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <ChemicalRuleViolationTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
    </>
  );
};
export default IpsReportHome;
